export function capitalize(str: string): string {
    if (str.length < 1) {
        return "";
    }
    if (str.length == 1) {
        return str.toUpperCase();
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// generates an error code which is visible by the end user so it should not contain rude language
export function generateCleanRandomString(idLength: number = 6): string {
    const safeChars = "BCDFGHJKLMNPQRSTVWXYZ23456789";
    const bannedSubstrings = [
        "FCK",
        "BS",
        "CNDM",
        "SHT",
        "DCK",
        "CNT",
        "KNT",
        "FKN",
        "WTF",
        "LSD",
        "THC",
        "COK",
        "JZZ",
        "XXX",
        "FKU",
    ];

    let id: string;
    const containsBannedSubstring = (str: string): boolean => bannedSubstrings.some((sub) => str.includes(sub));

    do {
        id = "";
        for (let i = 0; i < idLength; i++) {
            id += safeChars.charAt(Math.floor(Math.random() * safeChars.length));
        }
    } while (containsBannedSubstring(id));

    return id;
}

export function replaceUmlaute(input: string): string {
    const replacements: { [key: string]: string } = {
        Ä: "Ae",
        Ö: "Oe",
        Ü: "Ue",
        Æ: "Ae",
        Â: "A",
        Á: "A",
        À: "A",
        Å: "A",
        Ā: "A",
        Ã: "A",
        Ê: "E",
        É: "E",
        È: "E",
        Ë: "E",
        Ė: "E",
        Ô: "O",
        Ò: "O",
        Ó: "O",
        Õ: "O",
        Œ: "Oe",
        Ø: "O",
        Ō: "O",
        Û: "U",
        Ù: "U",
        Ú: "U",
        Ū: "U",
        ẞ: "SS",
        Ś: "S",
        Š: "S",
        ä: "ae",
        ö: "oe",
        ü: "ue",
        æ: "ae",
        œ: "oe",
        â: "a",
        á: "a",
        à: "a",
        å: "a",
        ā: "a",
        ã: "a",
        ê: "e",
        é: "e",
        è: "e",
        ė: "e",
        ë: "e",
        ø: "o",
        ô: "o",
        ó: "o",
        ò: "o",
        ō: "o",
        õ: "o",
        û: "u",
        ú: "u",
        ù: "u",
        ū: "u",
        š: "s",
        ś: "s",
        ß: "ss",
    };
    return input.replace(/[\u00C0-\u017F\u1E9E]/g, (char) => replacements[char] || char);
}

export function toCamelCase(str: string): string {
    if (!str) return str;
    let shouldConvertNextCharToLower = true;
    const delimiter = " ";
    let builder = "";

    for (let i = 0; i < str.length; i++) {
        const currentChar = str.charAt(i);
        if (currentChar === delimiter) {
            shouldConvertNextCharToLower = false;
        } else if (shouldConvertNextCharToLower) {
            builder += currentChar.toLowerCase();
        } else {
            builder += currentChar.toUpperCase();
            shouldConvertNextCharToLower = true;
        }
    }
    return builder;
}

export function buildDeclarativeIdString(str: string): string {
    const REGEX_NON_LETTER_NUMBER = /[^a-zA-Z0-9]/g;

    const replacedUmlaute = replaceUmlaute(str);
    let cleaned = replacedUmlaute.replace(REGEX_NON_LETTER_NUMBER, " ");
    // trim after cleaning so leading/trailing punctuation doesn't capitalize the first word
    cleaned = cleaned.replace(/ {2}/g, " ").trim();

    const capitalized = toCamelCase(cleaned);
    return capitalized.replace(/ /g, "");
}
